import React, { createContext, useState, useContext } from 'react';

interface LoadingContextType {
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

const LoadingContext = createContext<LoadingContextType>({
  loading: false,
  setLoading: () => {},
});

export const useLoadingContext = () => useContext(LoadingContext);

// eslint-disable-next-line react/function-component-definition
export const LoadingProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [loading, setLoading] = useState<boolean>(false);

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const value = {
    loading,
    setLoading,
  };

  return <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>;
};
